import script from "./EstadisticasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EstadisticasComponent.vue?vue&type=script&setup=true&lang=js"

import "./EstadisticasComponent.vue?vue&type=style&index=0&id=9dd16872&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd16872"]])

export default __exports__